import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "boxed-price-lock-component" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { style: {"margin-top":"16px"} }, "Boxed Price Lock", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "Upload file to update price lock", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Upload CSV ")
const _hoisted_5 = {
  key: 0,
  style: {"padding-top":"7.5px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Upload File")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_outlined = _resolveComponent("upload-outlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_a_form_item, { label: "CSV" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  "file-list": _ctx.fileList,
                  "before-upload": _ctx.beforeUpload
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_upload_outlined),
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    (_ctx.csvFileLabel !== null && _ctx.csvFileLabel !== undefined && _ctx.csvFileLabel.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.csvFileLabel), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["file-list", "before-upload"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  loading: _ctx.loadingUpload,
                  onClick: _ctx.uploadCsv
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}